import React, { useEffect, useRef, useState } from 'react'
import styles from './CustomSelectInputs.module.css'
import { DarkLoader } from '../Loader/Loader'
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox'

const CustomSelectInput = (props: any) => {
	const [searchVal, setsearchVal] = useState('')
	const [noData, setnoData] = useState(false)
	const wrapperRef = useRef<HTMLDivElement>(null)

	const searchHandler = (val: any) => {
		let noDataFound = props?.data?.filter((country: any) => country?.name?.toLowerCase()?.includes(val?.toLowerCase()))
		if (noDataFound?.length === 0) {
			setnoData(true)
		} else setnoData(false)
	}

	// close dropdown if clicked elsewhere
	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (props?.showSelectMenu) {
				if (wrapperRef?.current && !wrapperRef.current.contains(e.target as Node)) {
					props?.setshowSelectMenu(false)
					setnoData(false)
					setTimeout(() => {
						setsearchVal('')
					}, 300)
				}
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [props?.showSelectMenu, props?.setshowSelectMenu])

	return (
		<div
			ref={wrapperRef}
			className={`${props?.input_errors ? 'border-red-400 focus:border-red-400' : 'border-gray-300'} ${styles.input} ${styles.list_container} ${props?.input_errors ? 'input-error' : undefined} ${props?.className} border-[1px] border-solid border-gray-300 list-container custom-select-container`}
			tabIndex={0}
		>
			<div className={`white-bg ${styles.val_wrapper}`} onClick={() => props?.setshowSelectMenu(!props?.showSelectMenu)}>
				{props?.dataLoading && props?.dataLoading !== undefined ? (
					<DarkLoader className='flex !justify-start items-center w-full' />
				) : (
					<div className={props?.data?.length > 0 || props?.countryNotSelected ? 'text-gray-500' : 'text-red-500'}>{(props?.data?.length > 0 || props?.countryNotSelected) && !props?.isEdit ? props?.defaultOption : props?.isEdit ? props?.editValue : `No ${props?.name} found`}</div>
				)}
				{props?.data !== undefined && props?.data?.length > 0 && (
					<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='gray'>
						<path strokeLinecap='round' strokeLinejoin='round' d='M19.5 8.25l-7.5 7.5-7.5-7.5' />
					</svg>
				)}
			</div>

			{props?.data?.length > 0 && (
				<div className={`${styles.list_wrapper} border-[1px] border-solid border-gray-300 ${props?.showFrom === 'top' ? styles.from_top : undefined} ${props?.showSelectMenu && (props?.showFrom === 'top' ? styles.show_from_top : styles.show_select_menu)} shadow transition `}>
					{props?.showSearch && (
						<div className={`${styles.searh_wrapper} border-[1px] border-solid border-gray-300`}>
							<input
								type='search'
								placeholder={props?.placeholder}
								value={searchVal}
								onChange={(e) => {
									setsearchVal(e.target.value), searchHandler(e.target.value)
								}}
							/>
							<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='var(--gray-icon)'>
								<path strokeLinecap='round' strokeLinejoin='round' d='M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z' />
							</svg>
						</div>
					)}

					{props?.data
						?.filter((data: any) => {
							if (searchVal === '') {
								return data
							} else if (data?.name?.toLowerCase()?.includes(searchVal?.toLowerCase())) {
								return data
							}
						})
						?.map((data: any, i: number) => {
							return (
								<CustomCheckbox
									closemodal={props?.closemodal}
									checked={props?.defaultOption === data?.name ? true : false}
									className={`${props?.name}-input custom-select cursor-pointer`}
									key={i}
									type='radio'
									labeltitle={data?.name}
									value={data?.id ? data?.id : data?.name}
									title={data?.name}
									name={props?.name}
									onChange={props?.onChange}
									onClick={(e: any) => {
										props?.onClick && props?.onClick(e), props?.setshowSelectMenu(false)
										setTimeout(() => {
											setsearchVal('')
										}, 200)
									}}
								/>
							)
						})}
					{!props?.dataLoading && noData && <div className={`${styles.no_data} text-red-500`}>No {props?.name} found</div>}
				</div>
			)}
		</div>
	)
}

export default CustomSelectInput
